import createReducer from './createReducer'
import { FIJAR_USUARIOS } from '../actions/Types'

const initialState = {
  data: []
}

export const usuarios = createReducer(initialState, {
  [FIJAR_USUARIOS]: (state, { usuarios }) => ({ ...state, data: usuarios })
})